import { Button, Flex, Text } from '@chakra-ui/react';
import useCurrencyText from 'hooks/shared/useCurrencyText';
import AppCard from 'presentation/components/shared/card/AppCard';
import CardInfoRow from 'presentation/components/shared/card/CardInfoRow';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  sharePrice: number | null;
  volume: number | null;
  quantity: number | null;
  lastRoundVolume: number | null;
  currency: Currency;
  onBuyClick: () => void;
}

const PeCompanyRelatedOrderItem: FC<Props> = ({
  sharePrice,
  volume,
  quantity,
  lastRoundVolume,
  currency,
  onBuyClick,
}) => {
  const { t } = useTranslation();

  const currencyText = useCurrencyText();

  const horizontalGap = 20;

  const rowWidth = `calc(50% - ${horizontalGap / 2}px)`;

  return (
    <AppCard py="15px" px="20px">
      <Flex flexWrap="wrap" mb="15px" justifyContent="space-between">
        {typeof sharePrice === 'number' && (
          <CardInfoRow w={rowWidth} label={t('pePrice')}>
            <Text>{currencyText(sharePrice, { symbol: currency.symbol })}</Text>
          </CardInfoRow>
        )}
        {typeof volume === 'number' && (
          <CardInfoRow w={rowWidth} label={t('peOfferPrice')}>
            <Text>{currencyText(volume, { symbol: currency.symbol })}</Text>
          </CardInfoRow>
        )}
        {typeof quantity === 'number' && (
          <CardInfoRow w={rowWidth} label={t('peSharesQuantity')}>
            <Text>{quantity}</Text>
          </CardInfoRow>
        )}
        {typeof lastRoundVolume === 'number' && (
          <CardInfoRow w={rowWidth} label={t('peLastRoundVolume')}>
            <Text>
              {currencyText(lastRoundVolume, { symbol: currency.symbol })}
            </Text>
          </CardInfoRow>
        )}
      </Flex>
      <Button onClick={onBuyClick} w="full">
        {t('buy')}
      </Button>
    </AppCard>
  );
};

export default PeCompanyRelatedOrderItem;
